<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    双龙站<br>
站点介绍<br>
双龙站位于深圳市龙岗区龙岗阁龙岗大道旁, 东侧为深汕路、西侧为龙岗大道、北侧为龙西东路。双龙站装修设计以白色为主色调，柱体采用白色搪瓷钢板，在标准化、简约化的装修中赋予了车站浓厚的文化气息。该站为高架站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:19	23:00	3号线	2分15-20秒	4分30秒<br>
双龙	--	--	3号线	2分15-20秒	4分30秒<br>
大运	06:09	23:18	16号线	5分32秒	6分41秒<br>
田心	06:14	23:30	16号线	5分32秒	6分41秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:20	23:00	3号线	3分15秒	5分钟<br>
双龙	--	--	3号线	3分15秒	5分钟<br>
大运	06:19	23:18	16号线	5分50秒	6分钟-9分钟<br>
田心	06:20	23:30	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:20	00:00	3号线	3分15秒	5分钟<br>
双龙	--	--	3号线	3分15秒	5分钟<br>
大运	06:19	00:18	16号线	5分50秒	6分钟-9分钟<br>
田心	06:20	00:30	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道南侧（西）、柏龙广场、怡龙风景园、颐景峰苑（一城峰景）、龙岗长途汽车站、翠竹邨、双龙天虹<br><br>
B出入口:<br>
龙岗大道南侧（东）、龙岗小学、三和村、中和街、双龙天虹<br><br>
C出入口:<br>
龙岗大道北侧（东）、龙平路、龙岗社区、深圳市龙岗区中心医院<br><br>
D出入口:<br>
龙岗大道北侧（西）、龙岗老街、平冈中学、龙岗邮政支局、富佳街<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 双龙地铁站①②<br>
E25路,M275路,M280路,M307路,M308路,M316路,M386路,,351路,810路,811路,862路,M361路,M447路,深惠1线,深惠3A,365路,E6路,E7路,E23路，M139路，M239路，M239路大站快车，M396路，M432路，M497路，E33路，E34路<br><br>
B出入口:<br>
公交站名： 双龙地铁站③<br>
E21路,M266路,M268路,M277路,M278路,M304路,M305路,M359路,M431路,深惠2线,366路,818路,B669路,M230路，M546路，M569路<br><br>
C出入口:
公交站名： 双龙地铁站①②<br>
M275路,M280路,M307路,M308路,M316路,M386路,351路,810路,811路,862路,M359路,M361路,M431路,深惠1线,深惠3A,366路,818路,M230路,M266路,M268路,M277路,M278路,M304路,M305路，M497路，M546路，M239路，M239路大站快车，M396路，M432路<br><br>
D出入口:<br>
公交站名： 双龙地铁站③<br>
E21路,E23路,E25路,M447路,深惠2线,365路,E6路,E7路，M139路，E33路，E34路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shiliuhaoxian",
          title: "16号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>



